import { openDB, type DBSchema, type IDBPDatabase } from 'idb';
import type { ParlaySelection } from '@/types/parlay';

const DB_NAME = 'parlay-bet-slip';
const DB_VERSION = 1;
const STORE_NAME = 'selections';

interface ParlayBetSlipDb extends DBSchema {
  selections: {
    key: string;
    value: ParlaySelection;
    indexes: {
      eventId: string;
    };
  };
}

let parlayDbPromise: Promise<IDBPDatabase<ParlayBetSlipDb>> | null = null;

const getParlayDb = () => {
  if (!parlayDbPromise) {
    parlayDbPromise = openDB<ParlayBetSlipDb>(DB_NAME, DB_VERSION, {
      upgrade(db) {
        const store = db.createObjectStore(STORE_NAME, { keyPath: 'id' });
        store.createIndex('eventId', 'eventId');
      },
    });
  }

  return parlayDbPromise;
};

export const getStoredParlaySelections = async () => {
  const db = await getParlayDb();
  return db.getAll(STORE_NAME);
};

export const saveStoredParlaySelection = async (selection: ParlaySelection) => {
  const db = await getParlayDb();
  await db.put(STORE_NAME, selection);
};

export const deleteStoredParlaySelection = async (selectionId: string) => {
  const db = await getParlayDb();
  await db.delete(STORE_NAME, selectionId);
};

export const clearStoredParlaySelections = async () => {
  const db = await getParlayDb();
  await db.clear(STORE_NAME);
};
